import { render } from "./privaciadadPrincipal.vue?vue&type=template&id=d5a3f61a"
const script = {}

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__